import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { formatText } from '../../../../helpers/value'
import { selectScreeningIndicatorById } from '../../../../tool/screening/common/store/slice'
import {
  getCompanyStatus,
  getCompanyType,
  getICB,
  getLegalForm,
  getLocation,
  getScreeningIndicators,
  getVSIC,
} from '../../../../tool/screening/common/store/thunk'
import { SelectedCriteria } from '../../../../tool/screening/exportFileSetting/selectedCriteria'
import {
  selectCurrencies,
  selectNumberOfCompany,
  selectSortBy,
  selectViews,
} from '../../../../tool/screening/exportFileSetting/store/slice'
import { HeaderPanel } from '../../../common/HeaderPanel'

export const ItemScreeningReport = () => {
  const dispatch = useDispatch()

  const numberCompany = useSelector(selectNumberOfCompany)
  const currencies = useSelector(selectCurrencies)
  const sortBy = useSelector(selectSortBy)
  const locale = useSelector((state) => state.i18n.locale)
  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())

  const [isFirstRender, setFirstRender] = useState(true)

  const viewsData = useSelector(selectViews)
  const data = viewsData
    .filter(
      (item, index) =>
        viewsData.findIndex((view) => view.groupId === item.groupId) === index,
    )
    .map((item) => ({
      ...item,
      ...screeningIndicatorById[item.screeningIndicatorId],
    }))

  useEffect(() => {
    if (!isFirstRender) {
      dispatch(getScreeningIndicators())
      dispatch(getVSIC())
      dispatch(getICB())
      dispatch(getLocation())
      dispatch(getCompanyStatus())
      dispatch(getLegalForm())
      dispatch(getCompanyType())
    }
    setFirstRender(false)
  }, [locale])

  return (
    <div>
      <HeaderPanel
        contentLeft="screening.SELECTED_CRITERIA"
        isI18n
        style={{ borderTop: '8px solid #FFFFFF' }}
      />
      <SelectedCriteria autoHeight autoHeightMax={500} />
      <HeaderPanel
        contentLeft="userManagement.orderManagement.orderDetail.NUMBER_OF_COMPANIES"
        isI18n
        contentRight={numberCompany}
        style={{ borderBottom: '1px solid #FFFFFF' }}
      />
      {!!screeningIndicatorById[sortBy?.screeningIndicatorId]
        ?.screeningIndicatorName && (
        <HeaderPanel
          contentLeft="screening.SORT_BY"
          isI18n
          contentRight={`${formatText(
            screeningIndicatorById[sortBy?.screeningIndicatorId]
              ?.screeningIndicatorName,
          )} ( ${sortBy?.sortDirection})`}
          style={{ borderBottom: '1px solid #FFFFFF' }}
        />
      )}

      <HeaderPanel
        contentLeft="screening.TOTAL_INFORMATION"
        isI18n
        contentRight={currencies.join(',  ')}
      />
      <ScrollComponent
        autoHeight
        autoHeightMax={500}
        appendStyle={{ padding: '8px 20px', backgroundColor: '#F3F3F3' }}
      >
        <Element className="fw600">
          <Translate value="screening.DEFAULT_INFO" />
        </Element>
        <Element>
          {!!data.length &&
            data.map((item) => {
              return (
                <Element
                  key={item.groupId}
                  className="fw600"
                  elementName="p"
                  style={{ padding: '5px 0' }}
                >
                  {`${item?.screeningIndicatorName} ( ${item?.year} )`}
                </Element>
              )
            })}
        </Element>
      </ScrollComponent>
    </div>
  )
}
